import { PureComponent } from 'react'
import { Field as FinalFormField } from 'react-final-form'

import { isDeepEqual } from '@/server-data'

import TagsListField from './TagsListField'
import { PublicProps as Props, FieldRenderProps } from './typings'

export default class TagsListFieldWrapper extends PureComponent<Props> {
  render() {
    const { name, ...props } = this.props

    return (
      <FinalFormField
        {...props}
        name={name}
        isEqual={isDeepEqual}
        render={(formProps: FieldRenderProps) => {
          return <TagsListField {...this.props} formProps={formProps} />
        }}
      />
    )
  }
}
